var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[(!_vm.isEmpty)?_c('HereMap'):_c('div',[_c('span',{staticClass:"no-location-text"},[_vm._v("Location Not Available")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }